import { forgotPasswordInputSchema, passwordResetAcceptedSchema } from '@canopee/contracts';
import { useMutation } from '@tanstack/react-query';
import { useState, type SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';

import { apiRequest } from '../../api/client.js';
import styles from '../login/login-screen.module.css';

export function ForgotPasswordScreen() {
  const [formError, setFormError] = useState<string | null>(null);
  const requestReset = useMutation({
    mutationFn: (input: unknown) =>
      apiRequest('/api/v1/auth/password/forgot', passwordResetAcceptedSchema, {
        method: 'POST',
        body: input,
      }),
  });

  function submit(event: SyntheticEvent<HTMLFormElement, SubmitEvent>) {
    event.preventDefault();
    setFormError(null);
    const data = new FormData(event.currentTarget);
    const parsed = forgotPasswordInputSchema.safeParse({ email: data.get('email') });
    if (!parsed.success) {
      setFormError('Saisissez une adresse email valide.');
      return;
    }
    requestReset.mutate(parsed.data);
  }

  return (
    <main className={styles.page}>
      <form className={styles.card} onSubmit={submit}>
        <div>
          <p className={styles.eyebrow}>Canopée</p>
          <h1>Mot de passe oublié</h1>
          <p>Recevez un lien temporaire si un compte actif correspond à cette adresse.</p>
        </div>
        <label className={styles.field}>
          <span>Email</span>
          <input autoComplete="email" name="email" required type="email" />
        </label>
        {requestReset.isSuccess ? (
          <p aria-live="polite" className={styles.success} role="status">
            Si un compte actif correspond, un email de réinitialisation a été préparé.
          </p>
        ) : null}
        {requestReset.isError || formError !== null ? (
          <p aria-live="polite" className={styles.error} role="alert">
            {requestReset.isError ? requestReset.error.message : formError}
          </p>
        ) : null}
        <button className={styles.submit} disabled={requestReset.isPending} type="submit">
          {requestReset.isPending ? 'Envoi…' : 'Envoyer'}
        </button>
        <Link className={styles.link} to="/login">
          Retour à la connexion
        </Link>
      </form>
    </main>
  );
}
